/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Instructions_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Describe the assistant's role and how it should respond, for example 'You are a support agent; answer in a friendly tone and cite the handbook.' Think of it ..." |
*
* @param {Uno_Edu_Project_Instructions_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_instructions_chip1_answer = /** @type {((inputs?: Uno_Edu_Project_Instructions_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Instructions_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreiben Sie die Rolle des Assistenten und wie er antworten soll, zum Beispiel: 'Sie sind ein Support-Mitarbeiter; antworten Sie in freundlichem Ton und verweisen Sie auf das Handbuch.' Betrachten Sie es als Verwandlung des Projekts in einen spezialisierten Assistenten.")
	return /** @type {LocalizedString} */ ("Describe the assistant's role and how it should respond, for example 'You are a support agent; answer in a friendly tone and cite the handbook.' Think of it as turning the project into a specialized assistant.")
});